<template>
    <div class="wapper">
        <div class="query-wapper">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-input placeholder="分类编码" v-model="query.categoryCode"></el-input>
                </el-col>
                <el-col :span="6">
                    <el-input placeholder="分类名称" v-model="query.categoryName"></el-input>
                </el-col>
                <el-col :span="6">
                    <el-input placeholder="分类简称" v-model="query.categoryAbbr"></el-input>
                </el-col>
                <el-col :span="6">
                    <el-input placeholder="说明" v-model="query.remarks"></el-input>
                </el-col>
            </el-row>
            <div class="button-wapper">
                <el-button plain @click="getInfoList(undefined)">查询</el-button>
                <el-button plain @click="reset">重置</el-button>
                <el-button plain v-auth="'import'" @click="batchImport">批量导入</el-button>
            </div>
        </div>
        <div class="content-wapper" v-if="infos">
            <el-table :data="infos" size='mini' empty-text :border="true">
                <el-table-column prop="categoryCode" label="税收分类编码"></el-table-column>
                <el-table-column prop="categoryName" label="税收分类名称"></el-table-column>
                <el-table-column prop="categoryAbbr" label="税收分类简称"></el-table-column>
                <el-table-column prop="remarks" label="说明"></el-table-column>
                <el-table-column prop="rateList" label="税率"></el-table-column>
                <el-table-column prop="version" label="版本号"></el-table-column>
                <el-table-column prop="creatorName" label="创建人"></el-table-column>
                <el-table-column prop="gmtModified" label="最后修改时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="170">
                    <template slot-scope="scope">
                        <el-button @click="edit(scope.row)" type="text" size="small" v-auth="'edit'">编辑</el-button>
                        <el-button @click="getDetailView(scope.row.categoryCode)" type="text" v-auth="'view'"
                            size="small">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page.sync="query.pageIndex" :page-size="query.pageSize"
                @current-change="handleCurrentChange" class="pagation" layout="prev, pager, next, jumper"
                :total="query.total">
            </el-pagination>
        </div>
        <!-- 批量导入弹窗 -->
        <el-dialog title="批量导入税收分类编码" destroy-on-close :visible.sync="dialogVisible" width="50%">
            <div class="info">
                <span>温馨提醒</span>
                <span>1、上传导入文件必须是 .xls或 .xlsx格式</span>
                <span>2、请严格按照导入模板格式处理数据，确保上传的文档中无空格等特殊字符；</span>
            </div>
            <div class="one">
                <span>Step1：下载文档模板，按照要求处理数据</span>
                <el-button @click="getDetail()" size="small">下载模板</el-button>
            </div>
            <div class="two">
                <span>Step2：导入处理好的数据文档</span>
                <input @change="fileChange($event)" type="file"
                    accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                <!-- <Upload :tipInfo="tipInfo"
                @onSuccess="onSuccess"
                :limit="1"
                :listType="'text'"></Upload> -->
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitImport">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Upload from '@/views/common/Upload.vue'
import _tax from '@/service/tax-service'
export default {
    components: {
        Upload
    },
    data() {
        return {
            dialogVisible: false,
            infos: null,
            tipInfo: '',
            file: null,
            query: {
                categoryCode: null,
                categoryName: null,
                categoryAbbr: null,
                remarks: null,
                pageIndex: 1,
                pageSize: 20
            }
        }
    },
    methods: {
        getInfoList(pageIndex) {
            if (pageIndex) {
                this.$set(this.query,'pageIndex',pageIndex)
            } else
            this.$set(this.query,'pageIndex',1)
            _tax.taxCategoryList(
                this.query,
                (response, total) => {
                    // 请求成功
                    this.infos = response
                    this.query.total = total
                })
        },
        batchImport() {
            this.dialogVisible = true
        }, submitImport() {
            if (this.file == null) {
                this.$notify({
                    message: '请选择文件',
                    type: 'warning'
                })
                return
            }
            let _loading = this.$loading({ fullscreen: true })
            _tax.importData(
                this.file,
                response => {
                    _loading.close()
                    this.$notify({
                        message: '上传成功',
                        type: 'warning'
                    })

                    getInfoList()

                    // 请求成功
                    this.dialogVisible = false

                }, response => {
                    _loading.close()
                    this.$notify({
                        message: response,
                        type: 'warning'
                    })
                })


        },
        fileChange(e) {
            this.file = e.target.files[0]
        },

        //详情数据
        getDetail() {
            location.href = 'https://rs.juyoufuli.com/static/excel/税收分类导入模板.xlsx'

        },
        getDetailView(categoryCode) {
            this.$router.push('/tax-category-detail?categoryCode=' + categoryCode)
        },
        //重置事件
        reset() {
            this.query = {}
            getInfoList()
        },
        //页码事件
        handleCurrentChange(pageIndex) {
            getInfoList(pageIndex)
        },
        edit(row) {
            this.$saveParams(this.query)
            this.$router.push({
                path: '/add-royalty-plan?id=' + row.id + "&type=edit"
            })
        },

        planStateUpdate(rows) {
            _royaltyPlan.planStateUpdate(rows.id, rows.state, () => {
                this.$notify({
                    message: '修改成功',
                    type: 'success'
                });
            })
        }
    },
    created() {
        this.getInfoList()
    }

}

</script>

<style scoped>
.wapper {
    padding: 15px;
}

.header {
    margin-bottom: 15px;
}

.query-wapper {
    margin: 15px;
    padding: 15px;
    border: 1px solid #d6dbe5;
    position: relative;
    background: #fff;
}

.query-wapper::after {
    position: absolute;
    content: "筛选条件";
    top: -9px;
    color: #909399;
    background-color: #fbfbfb;
}

.content-wapper {
    padding: 0 15px;
    padding-bottom: 30px;
}

.button-wapper {
    margin-top: 10px;
}

.el-row {
    margin-bottom: 15px;
}

.info {
    display: flex;
    padding-bottom: 15px;
    border-bottom: 1px solid rgb(226, 226, 226);

    flex-direction: column;
}

.info span:first-child {
    font-weight: bold;
    margin-bottom: 15px;
}

.one {
    font-weight: bold;
    margin-top: 20px;
}

.one span {
    margin-right: 20px;
}

.two {
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-top: 20px;
}

.two span:first-child {
    margin-right: 20px;
}
</style>